import React from "react";
import { Link } from "react-router-dom";
import { BarChart3, Settings } from "lucide-react";
import { AppHubHeroCta, AppHubShell } from "@tennis-matches/ui-components";
import { buildTournamentHref } from "../../../utils/href.js";
import { CLUBCHAMP_HUB_HERO } from "./clubchampHubMedia.js";
import { ClubChampTournamentsSection } from "./ClubChampTournamentsSection.jsx";

function __asStr(v) {
  return String(v ?? "").trim();
}

function __isClubChampKind(kind) {
  const k = __asStr(kind).toLowerCase();
  return k === "clubmeisterschaft" || k === "clubchamp" || k === "courtleague";
}

/**
 * @param {{
 *   t: (k: string, p?: object) => string,
 *   items?: Array<object>,
 *   loading?: boolean,
 *   onNewTournament: () => void,
 *   onListChanged?: () => void | Promise<void>,
 * }} props
 */
export function ClubChampHubDashboard({
  t,
  items = [],
  loading = false,
  onNewTournament,
  onListChanged: _onListChanged,
}) {
  const tr = typeof t === "function" ? t : (k) => k;
  const newHref = buildTournamentHref({
    appKey: "clubmeisterschaft",
    intent: "new",
  });
  const statsHref = "/hub/insights/clubmeisterschaft";

  return (
    <AppHubShell
      hero={{
        ariaLabel: tr("hub.clubmeisterschaft.hero.aria"),
        brand: tr("hub.clubmeisterschaft.title"),
        tagline: tr("hub.clubmeisterschaft.quickStart.tagline"),
        title: tr("hub.clubmeisterschaft.hero.title"),
        subtitle: tr("hub.clubmeisterschaft.hero.subtitle"),
        media: {
          src: CLUBCHAMP_HUB_HERO.src,
          srcWide: CLUBCHAMP_HUB_HERO.srcWide,
          srcSet: `${CLUBCHAMP_HUB_HERO.src} 960w, ${CLUBCHAMP_HUB_HERO.srcWide} 1440w`,
          width: 1440,
          height: 480,
        },
        primaryAction: (
          <AppHubHeroCta
            as={Link}
            to={newHref}
            onClick={() => onNewTournament?.()}
          >
            {tr("hub.clubmeisterschaft.hero.cta")}
          </AppHubHeroCta>
        ),
      }}
      secondary={{
        ariaLabel: tr("hub.clubmeisterschaft.secondary.aria"),
        items: [
          {
            key: "stats",
            label: tr("hub.clubmeisterschaft.secondary.stats"),
            icon: BarChart3,
            href: statsHref,
            as: Link,
          },
          {
            key: "settings",
            label: tr("hub.clubmeisterschaft.secondary.settings"),
            icon: Settings,
            disabled: true,
          },
        ],
      }}
      footerTagline={tr("hub.clubmeisterschaft.footer.tagline")}
    >
      <ClubChampTournamentsSection
        t={tr}
        items={items}
        loading={loading}
        statsHref={statsHref}
      />
    </AppHubShell>
  );
}

export { __isClubChampKind };
